import { Grid, TextField, Typography, Button, Link, Stack } from '@mui/material'
import colors from '../../colors'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectRegistrationState, decrementCurrentRegistrationStep, setBirthdate, setFullName } from '../../../features/registration/registrationSlice'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { setToken } from '../../../features/global/globalDataSlice'
import { sendGeneralRequest } from '../../../features/generalRequest'
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LocalizationProvider } from '@mui/lab';
import moment from 'moment';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { selectTermsAndConditionsState } from '../../../features/termsAndConditions/termsAndConditionsSlice'
import { texts } from '../../general/texts'

export const BasicAccountFifthRegistrationStep = () => {

    const registrationSliceState = useSelector(selectRegistrationState)
    const termsAndConditionsSliceState = useSelector(selectTermsAndConditionsState)
    const dispatch = useDispatch()

    const validationSchema = yup.object({
        fullName: yup
            .string(texts["message-invalid-full-name"])
            .matches(/[a-zA-z]+\s[a-zA-z]+/, {
                message: "Formati i sakte eshte: Emër Mbiemër",
            })
            .required(texts["message-invalid-full-name"]),
        birthDate: yup
            .string(texts["message-invalid-birthdate"])
            // .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
            //     message:'Datelindja duhet te jete ne formatin DD/MM/YYYY'
            // })
            .required(texts["message-invalid-birthdate"])
            .nullable(),
        idTC: yup
            .bool()
            .oneOf([true], texts["message-invalid-terms-and-conditions"])
    });

    const formik = useFormik({
        initialValues: {
            token: registrationSliceState.token,
            fullName: '',
            city: '',
            address: '',
            fathersName: '',
            birthDate: '',
            gender: '',
            firstName: '',
            businessName: '',
            idTC: false,
            ext: registrationSliceState.idPictureExtension,
            base64Content: registrationSliceState.idPictureBase64,
            idNumber: registrationSliceState.idNumber,
            expiryDate: registrationSliceState.idExpiryDate,
            accountType: registrationSliceState.accountType,
            //identificationDocumentType:"N/A"
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            var splitFullName = values.fullName.split(/(\s+)/);
            dispatch(setToken(registrationSliceState.token))
            dispatch(sendGeneralRequest({ request: { _request: { ...values, nationality: '', idTC: termsAndConditionsSliceState.idTC, idPrivacyPolicy: termsAndConditionsSliceState.idPrivacyPolicy, birthDate: moment(values.birthDate).format('DD/MM/yyyy'), name: splitFullName[0].charAt(0).toUpperCase() + splitFullName[0].slice(1), surname: splitFullName[2].charAt(0).toUpperCase() + splitFullName[2].slice(1) } }, baseUrlKey: 'auth', endpoint: 'UpdateUserDataNew' }))

        }
    })

    const onBackButtonClick = () => {
        dispatch(setFullName(formik.values.fullName))
        dispatch(setBirthdate(formik.values.birthDate))
        dispatch(decrementCurrentRegistrationStep())
    }

    React.useEffect(() => {
        dispatch(sendGeneralRequest({ request: { _request: { TypeOfAccount: registrationSliceState.accountType } }, baseUrlKey: 'auth', endpoint: 'GetTermsAndConditions' }))
    }, [])


    React.useEffect(() => {
        formik.setFieldValue('fullName', registrationSliceState.fullName)
        formik.setFieldValue('birthDate', registrationSliceState.birthDate)
    }, [registrationSliceState.fullName, registrationSliceState.birthDate])


    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container item sx={{ width: '60%', ml: '10%', '@media (max-width: 899px )': { width: '95%', ml: '20%' } }}  >
                    <Grid container item md={6} xs={12} mb={10} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography sx={{ color: colors.orange, fontSize: '1.2rem', fontFamily: 'GerberaMedium' }} variant="h6">{texts["title-full-name"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="fullName" name="fullName" onChange={formik.handleChange} value={formik.values.fullName} error={formik.touched.fullName && Boolean(formik.errors.fullName)} helperText={formik.touched.fullName && formik.errors.fullName} color={'warning'} placeholder={texts["placeholder-full-name-basic"]} variant="standard" sx={{ width: '15vw', '@media (max-width: 899px)': { width: '70vw' } }} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={10} flexDirection='column'>
                        <Grid container justifyContent='flex-start' mb={2}><Typography sx={{ color: colors.orange, fontSize: '1.2rem', fontFamily: 'GerberaMedium' }} variant="h6">{texts["title-registration-birthdate"]}</Typography></Grid>
                        <Grid container justifyContent='flex-start'>
                            {/* <TextField id="birthDate" name="birthDate" onChange={formik.handleChange} value={formik.values.birthDate} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} helperText={formik.touched.birthDate && formik.errors.birthDate} color={'warning'} placeholder='DD/MM/YYYY' variant="standard" sx={{width:'60%'}} /> */}
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        openTo="day"
                                        views={['day', 'month', 'year']}
                                        value={formik.values.birthDate}
                                        id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                        renderInput={(params) =>
                                            <TextField variant="standard" id='birthDate' name='birthDate' placeholder='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} sx={{ width: '15vw', '@media (max-width: 899px)': { width: '70vw' } }}  {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection={'column'} justifyContent={'flex-end'} mt={6}>
                        <FormGroup>
                            <FormControlLabel onChange={formik.handleChange} control={<Checkbox id="idTC" name="idTC" checked={formik.values.idTC} sx={{ [`&.${checkboxClasses.checked}`]: { color: colors.orange }, color: colors.gray }} />}
                                label={<Typography textAlign="left" color={colors.gray} fontFamily={'GerberaLight'}>
                                    {texts["terms-and-conditions-confirm"]}
                                    <Link href={termsAndConditionsSliceState.termsAndConditionsUrl} target="_blank" style={{ color: colors.orange, marginRight: 5 }}><br />{texts["terms-and-conditions"]}</Link>
                                    {texts["and-separator"]}
                                    <Link href={termsAndConditionsSliceState.privacyUrl} target="_blank" style={{ color: colors.orange }}><br />{texts["privacy-politics"]}</Link>
                                    {texts["of-ep"]}
                                </Typography>
                                } />
                        </FormGroup>
                        {formik.touched.idTC && <FormHelperText error>{formik.errors.idTC}</FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} mt={20} >
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' sx={{ background: colors.gradientOrange, color: colors.white, width: '12%', fontFamily: 'GerberaBold', textTransform: 'none', fontSize: '1rem' }}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid item md={12} xs={12} pt={'0.8%'} pb={'5%'}>
                    <Link disabled={registrationSliceState.isLoading ? true : false} sx={{ color: colors.orange, textDecorationColor: colors.orange, fontFamily: 'GerberaLight', ":hover": { textDecorationColor: '#FF8403', color: '#FF8403' } }} onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
                </Grid>
            </Grid>
        </form>
    )
}
export default BasicAccountFifthRegistrationStep